<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">GHOST TOWN</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ghost-town_00000.vue?28b390d7